<template>
  <span v-if="collapsed">
    <StepForwardOutlined />
  </span>
  <span v-else class="collapse-item">
    <StepBackwardOutlined />
    <span class="collapse-label">Collapse</span>
  </span>
</template>
<script setup lang="ts">
import {
  StepBackwardOutlined,
  StepForwardOutlined,
} from '@ant-design/icons-vue'

defineProps<{ collapsed: boolean }>()
</script>
<style scoped>
.collapse-item {
  display: flex;
  align-items: center;
}
.collapse-label {
  font-size: 16px;
  line-height: 18px;
  padding: 0 0 0 5px;
}
</style>
